import React, { useState, useEffect, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { getBranchOwner, get, put, api } from "@config";
import { StyledCardHeader, SectionTitle, StyledInputGroup, ActionButton, LayoutGrid } from './styles';
import { useNfse } from '../context';

export default function RPS(props) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editData, setEditData] = useState({ rps_serie: 1, rps_number: 1 });
  const { setRps } = useNfse();

  const syncRpsState = useCallback((payload) => {
    if (!payload) return;
    setRps((prev) => {
      const previous = prev || {};
      const nextSerie = payload.rps_serie !== undefined && payload.rps_serie !== null ? payload.rps_serie : previous.rps_serie;
      const nextNumber = payload.rps_number !== undefined && payload.rps_number !== null ? payload.rps_number : previous.rps_number;
      const nextType = payload.rps_type !== undefined && payload.rps_type !== null ? payload.rps_type : (previous.rps_type !== undefined ? previous.rps_type : 1);

      return {
        ...previous,
        rps_serie: nextSerie,
        rps_number: nextNumber,
        rps_type: nextType,
      };
    });
  }, [setRps]);

  const fetchConfig = useCallback(() => {
    setLoading(true);
    const branch = getBranchOwner();
    get(
      `${api.nfse.config}?branch_owner=${branch.id}`,
      (resp) => {
        setConfig(resp);
        setEditData({ rps_serie: resp.rps_serie || 1, rps_number: resp.rps_number || 1 });
        syncRpsState(resp);
        setLoading(false);
      },
      (err) => setLoading(false)
    );
  }, [syncRpsState]);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  const saveConfig = () => {
    if (!config || !config.id) return;
    setSaving(true);
    const branch = getBranchOwner();
    const payload = {
      ...config,
      rps_serie: editData.rps_serie,
      rps_number: editData.rps_number,
    };
    
    put(
      `${api.nfse.config}${config.id}/?branch_owner=${branch.id}`,
      payload,
      (resp) => {
        setConfig(resp);
        setEditData({ rps_serie: resp.rps_serie || 1, rps_number: resp.rps_number || 1 });
        syncRpsState(resp);
        setSaving(false);
        setShowModal(false);
      },
      (err) => setSaving(false)
    );
  };

  if (loading || !config) {
    return null; // ou um loader sutil
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px', background: '#fff', border: '1px solid #EAECF0', borderRadius: '8px', padding: '12px 16px', marginBottom: '24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '24px', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <i className="fas fa-list-ol text-secondary"></i>
          <strong style={{ color: '#101828', fontSize: '0.95rem' }}>Numeração (RPS)</strong>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ fontSize: '0.75rem', color: '#667085', textTransform: 'uppercase', fontWeight: 600 }}>Série:</span>
            <strong style={{ color: '#101828', fontSize: '1rem' }}>{config.rps_serie}</strong>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ fontSize: '0.75rem', color: '#667085', textTransform: 'uppercase', fontWeight: 600 }}>Próximo Número:</span>
            <strong style={{ color: '#0088cc', fontSize: '1rem' }}>{config.rps_number}</strong>
          </div>
        </div>
      </div>
      <ActionButton variant="secondary" onClick={() => setShowModal(true)} style={{ padding: '6px 12px', fontSize: '0.85rem' }} $stackedOnMobile>
        <i className="fas fa-edit"></i> Editar
      </ActionButton>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <h4 className='m-0' style={{fontWeight: 700}}>Editar Numeração da NFS-e</h4>
        </Modal.Header>
        <Modal.Body>
          <p style={{ fontSize: '0.9rem', color: '#475467', marginBottom: '20px' }}>
            Atenção: A numeração geralmente é sequencial automática. Só altere se precisar sincronizar com a prefeitura após emissões avulsas fora do sistema.
          </p>
          <LayoutGrid>
            <StyledInputGroup>
              <label>Série da RPS *</label>
              <input
                type="text"
                name="rps_serie"
                value={editData.rps_serie}
                onChange={handleEditChange}
                disabled={saving}
              />
            </StyledInputGroup>
            <StyledInputGroup>
              <label>Próximo Número (RPS) *</label>
              <input
                type="number"
                name="rps_number"
                value={editData.rps_number}
                onChange={handleEditChange}
                disabled={saving}
              />
            </StyledInputGroup>
          </LayoutGrid>
        </Modal.Body>
        <Modal.Footer>
          <ActionButton variant="secondary" onClick={() => setShowModal(false)} disabled={saving}>
            Cancelar
          </ActionButton>
          <ActionButton variant="primary" onClick={saveConfig} disabled={saving}>
            {saving ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-save"></i>} 
            {saving ? "Salvando..." : "Salvar Numeração"}
          </ActionButton>
        </Modal.Footer>
      </Modal>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/emit/components/rps.jsx